import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CircleGroup1Component } from "../../includes/not-found-circles/circle-group-1/circle-group-1.component";
import { CircleGroup2Component } from "../../includes/not-found-circles/circle-group-2/circle-group-2.component";
import { CircleGroup3Component } from "../../includes/not-found-circles/circle-group-3/circle-group-3.component";
import { CircleGroup4Component } from "../../includes/not-found-circles/circle-group-4/circle-group-4.component";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'pc-not-found',
  standalone: true,
  imports: [CircleGroup1Component, CircleGroup2Component, CircleGroup3Component, CircleGroup4Component],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent implements OnInit, OnDestroy {
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(this.document.documentElement, 'not-found');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.documentElement, 'not-found');
  }
}
